import { isTrashView } from './viewOperators';
/**
 * @description `getViewCanSeeDeletedMessages` will return whether or not the
 * given view should show deleted messages when rendering threads.
 */
export function getViewCanSeeDeletedMessages(view) {
  return !!view && isTrashView(view);
}